import React, { useEffect, useState } from "react";

import FloatingPromo from "../../components/widgets/floatingPromo";
import { useTheme } from "../../context/ThemeContext";
import { formatCurrencyAmount } from "../../utils/formatContent";

const BlogPagePromoContainer = ({
  isShow,
  setShowFloating,
  stickyWidgetDetails,
  scholarships,
  post
}) => {
  const [showFloating, setCurrentShowFloating] = useState(false);
  const [isFloatClosed, closePromo] = useState(
    (typeof window !== "undefined" &&
      window.localStorage.getItem("isPromoFloatClosed")) ??
      false
  );
  const { currentSiteMeta } = useTheme();

  useEffect(() => {
    if (isFloatClosed === false) setCurrentShowFloating(isShow);
    else setCurrentShowFloating(false);
  }, [isShow, isFloatClosed]);

  useEffect(() => {
    window.localStorage.setItem("isPromoFloatClosed", isFloatClosed);
  }, [isFloatClosed]);

  const handleClosePromo = () => {
    closePromo(true);
    setShowFloating(false);
  };

  const currencyToUse = currentSiteMeta?.currency
    ? currentSiteMeta.currency.toLowerCase()
    : process.env.GATSBY_PROJECT_CURRENCY ?? "gbp";

  const exclusiveDiscount =
    scholarships.find(
      (discount) => discount.exclusiveDiscountCurrency === currencyToUse
    ) ?? [];

  const scholarshipAmount = exclusiveDiscount?.exclusiveDiscountAmount ?? "";

  const scholarshipAmountDisplay = formatCurrencyAmount({
    amount: scholarshipAmount,
    currentSiteMeta
  });

  const promoDetails = stickyWidgetDetails ?? [];

  const promoImage =
    post?.blogLeftStickyImage?.sourceUrl ??
    promoDetails?.gbcLeftFloatingWdgtImage?.sourceUrl;
  const promoTitle =
    post?.blogLeftStickyText ?? promoDetails?.gbcLeftFloatingWdgtTitle ?? "";
  const promoSubtitle = promoDetails?.gbcLeftFloatingWdgtSubtitle ?? "";
  const promoCtaTitle =
    post?.blogLeftStickyButtonTitle ??
    promoDetails?.gbcLeftFloatingWdgtCtaTitle;
  const promoCtaLink =
    post?.blogLeftStickyButtonLink ?? promoDetails?.gbcLeftFloatingWdgtCtaLink;

  const promoAmountTitle = promoTitle?.replace(
    "PROMO",
    scholarshipAmountDisplay
  );

  return (
    stickyWidgetDetails && (
      <FloatingPromo
        showFloating={showFloating}
        handleClosePromo={handleClosePromo}
        promoImage={promoImage}
        promoAmountTitle={promoAmountTitle}
        promoSubtitle={promoSubtitle}
        promoCtaLink={promoCtaLink}
        promoCtaTitle={promoCtaTitle}
      />
    )
  );
};

export default BlogPagePromoContainer;
